namespace SorAraBul.Administration {
    export interface PurchasePackagesForm {
        PackageCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Subtitle: Serenity.StringEditor;
        ReportCount: Serenity.IntegerEditor;
        UnitPrice: Serenity.DecimalEditor;
        CurrencyId: Serenity.LookupEditor;
        BadgeText: Serenity.StringEditor;
        ButtonText: Serenity.StringEditor;
        IsPopular: Serenity.BooleanEditor;
        SortOrder: Serenity.IntegerEditor;
        Features: PurchasePackageFeaturesEditor;
    }

    export class PurchasePackagesForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PurchasePackages';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PurchasePackagesForm.init)  {
                PurchasePackagesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.LookupEditor;
                var w4 = s.BooleanEditor;
                var w5 = PurchasePackageFeaturesEditor;

                Q.initFormType(PurchasePackagesForm, [
                    'PackageCode', w0,
                    'Name', w0,
                    'Subtitle', w0,
                    'ReportCount', w1,
                    'UnitPrice', w2,
                    'CurrencyId', w3,
                    'BadgeText', w0,
                    'ButtonText', w0,
                    'IsPopular', w4,
                    'SortOrder', w1,
                    'Features', w5
                ]);
            }
        }
    }
}
